module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ub uw uh ubgc-while-easy"
  }, [_c('div', {
    staticClass: "ub ub-ver ub-f1"
  }, [_c('div', {
    staticClass: "ub ub-ac uh-60 ubgc-main"
  }, [_c('img', {
    staticClass: "ub umar-l20 uw-40 ubor-r",
    attrs: {
      "src": require("../../assets/image/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ub uc-while ufs-26 umar-l10"
  }, [_vm._v(_vm._s(_vm.user.org ? _vm.user.org.name : '智能锁销售平台'))]), _vm._v(" "), _c('div', {
    staticClass: "ub ub-f1 ub-ac umar-r20"
  }, [_c('div', {
    staticClass: "ub ub-ac umar-l10"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.isCollapse),
      callback: function($$v) {
        _vm.isCollapse = $$v
      },
      expression: "isCollapse"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("展开")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("收起")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ub ub-ac ub-f1 ufs-20 uh uc-while umar-l20"
  }), _vm._v(" "), _c('div', {
    staticClass: "ub uc-while umar-r20"
  }, [_vm._v("\n          " + _vm._s(_vm.user.role ? _vm.user.role.name : '超级管理员') + " " + _vm._s(_vm.user.phone) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ub uc-grey umar-r20",
    on: {
      "click": function($event) {
        return _vm.toNewPage('/home/editPword')
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "close"
    }
  }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ub uc-grey",
    on: {
      "click": function($event) {
        return _vm.toNewPage('/login')
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "close"
    }
  }, [_vm._v("退出")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ub ub-f1"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "background-color": "#324157"
    },
    attrs: {
      "unique-opened": true,
      "collapse": _vm.isCollapse
    },
    on: {
      "select": _vm.toSelectMenu
    }
  }, _vm._l((_vm.menus.data), function(item) {
    return _c('div', [(item.children.length > 0) ? _c('el-submenu', {
      attrs: {
        "index": item.code
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: 'iconfont ufs-14 ' + item.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('el-menu-item-group', _vm._l((item.children), function(child) {
      return ((child.code != '100110110' && child.code != '100115105' && child.code != '100115110') || (_vm.user.org.code == '100100' && (child.code == '100110110' || child.code == '100115105' || child.code == '100115110'))) ? _c('el-menu-item', {
        attrs: {
          "index": child.url
        }
      }, [_c('i', {
        class: 'iconfont ufs-14 icon-radiobox'
      }), _vm._v("\n                " + _vm._s(child.name) + "\n              ")]) : _vm._e()
    }), 1)], 2) : _vm._e(), _vm._v(" "), (item.children.length == 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_c('i', {
      class: 'iconfont ufs-14 ' + item.icon
    }), _vm._v("\n            " + _vm._s(item.name) + "\n          ")]) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ub ub-ver ub-f1 umain"
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-331120fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = 660
// module chunks = 30